import { makeStyles, Tooltip } from "@fluentui/react-components";
import { useState } from "react";
import Icons from "./icons";

const useStyle = makeStyles({
    pointer: {
        cursor: "pointer"
    }
})

const CopyToClipboard = ({ textToCopy, placement, hideAfter, iconSize = 24 }) => {
    const [isCopied, setisCopied] = useState(false);
    const styles = useStyle();

    const copyLinkToClipboard = () => {
        navigator.clipboard.writeText(textToCopy)
        setisCopied(true)
        setTimeout(() => {
            setisCopied(false)
        }, hideAfter || 1000);
    }

    return (
        <Tooltip withArrow content={isCopied ? "Copied!" : "Copy"} relationship="label">
            <span className={styles.pointer} onClick={copyLinkToClipboard}>
                <Icons.CopyIcon size={iconSize} />
            </span>
        </Tooltip>
    )
}

export default CopyToClipboard